<template>
  <li>
    <span @dblclick="bdlClick">
      <i v-if="isOpen" class="fa fa-folder-open" />
      <i v-else class="fa fa-folder" />
      {{ name }}
    </span>
    <ul v-if="isOpen">
      <File v-for="file in content" :key="file.basename" :content="file" @attach-file="attachFile" />
    </ul>
  </li>
</template>

<script>
import File from './File';

export default {
  components: {
    File,
  },

  props: {
    content: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    isOpen: false,
  }),

  methods: {
    attachFile(url) {
      this.$emit('attach-file', url);
    },
    bdlClick(event) {
      event.preventDefault();
      this.isOpen = !this.isOpen;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Folder.vue?32c4b19a